import React from 'react';
import PropTypes from 'prop-types';
import { Svg } from 'app/components';
import { ListSocial, ListSocialItem } from './styles';
import { generateUniqueId } from 'utils';

const propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired
};

const ListSocialComponent = ({ items }) => (
  <ListSocial>
    {items.map(item => (
      <ListSocialItem key={item.title} id={`list-social-item-${generateUniqueId()}`}>
        <a
          href={item.url}
          target="_blank"
          className="l-social__item-link"
          aria-label='social-link'
          rel="noopener noreferrer"
          id={`social-item-link-${generateUniqueId()}`}
        >
          <Svg id={item.title} />
        </a>
      </ListSocialItem>
    ))}
  </ListSocial>
);

ListSocialComponent.propTypes = propTypes;
export default ListSocialComponent;
